import { useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { ROUTES } from 'utils/routeNames';
import {
  SuggestionsWrapper,
  SuggestionBlock,
  SuggestionImage,
  SuggestionTitleDescriptionBlock,
  SuggestionTitle,
  SuggestionDescription,
} from './styled';

export const Suggestions = ({ suggestions }) => {
  const navigate = useNavigate();

  return (
    <SuggestionsWrapper>
      {suggestions?.map((element) => (
        <SuggestionBlock
          onClick={() => navigate(`${ROUTES.SUGGESTION}/${element.id}`)}
          key={uuid()}
        >
          <SuggestionImage image={element.main_image} />
          <SuggestionTitleDescriptionBlock>
            <SuggestionTitle>{element.title}</SuggestionTitle>
            <SuggestionDescription
              dangerouslySetInnerHTML={{ __html: element.description }}
            />
          </SuggestionTitleDescriptionBlock>
        </SuggestionBlock>
      ))}
    </SuggestionsWrapper>
  );
};
